module.exports = __webpack_public_path__ + "7d9b6b4a0fd6fb1d0de92b55bae44b2c.png";